module.exports = __webpack_public_path__ + "static/media/background-call-01.f2681bda.jpg";